import React, { useMemo } from 'react';
import TimeGrid from './TimeGrid';
import { startOfDay } from '../../utils/calendarDates';

/** Day = the shared TimeGrid over a single local day. */
export default function DayView({ focusedDate, ...rest }) {
  const days = useMemo(() => [startOfDay(focusedDate)], [focusedDate]);
  return <TimeGrid days={days} {...rest} />;
}
